import { Component, ViewEncapsulation, ChangeDetectorRef, Renderer2, EventEmitter, Output, NgZone } from '@angular/core';
import { DispatchesService } from '../../../shared/services/dispatches.service';
import { GlobalsService } from '../../../shared/services/globals.service';
import { Subscription, fromEvent, Subject } from 'rxjs';
import { RowClassArgs, DataStateChangeEvent } from '@progress/kendo-angular-grid';
import { v_DispatchPartsOrderedBus } from '../../../shared/models/v_DispatchPartsOrderedBus';
import { BaseGridEditLineComponent } from '@app/cp/shared/base-components/base-grid-editline.component';
import { InventoryService } from '@app/cp/shared/services/inventory.service';
import { CommonFunctions } from '@app/cp/shared/static/common-functions';
import { aggregateBy } from '@progress/kendo-data-query';
import { MSCLFilterClass } from '@app/cp/shared/classes/filters/MSCLFilterClass';
import * as _ from 'lodash';
import { take, tap } from 'rxjs/operators';
import { FeatureFlagService } from "@app/cp/shared/services/feature-flag.service";
import { UseFeatureFlagSet, IFeatureFlagSet } from '@app/cp/shared/decorators/featureflags/featureflagset-decorator';

@UseFeatureFlagSet()
@Component({
    selector: 'dispatch-parts-ordered',
    templateUrl: './dispatch-parts-ordered.component.html',
    styleUrls: ['./dispatch-parts-ordered.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class DispatchPartsOrderedComponent extends BaseGridEditLineComponent<v_DispatchPartsOrderedBus, null, DispatchesService>  {
    compFeatureFlagSet: IFeatureFlagSet = this as any;
    supplierNameCF: MSCLFilterClass;
    inventoryNumberCF: MSCLFilterClass;
    orderNumberCF: MSCLFilterClass;

    @Output() dropEvent: EventEmitter<any> = new EventEmitter<any>();
    private currentSubscription: Subscription;
    private destroy$ = new Subject();
    constructor(globals: GlobalsService, renderer: Renderer2, private zone: NgZone, cd: ChangeDetectorRef, svc_data: DispatchesService, svc_inv: InventoryService, featureFlagService: FeatureFlagService) {
        super(globals, renderer, cd, featureFlagService);

        this.svc_data = svc_data;

        this.className = "v_DispatchPartsOrderedBus";
        this.appName = "Dispatch Parts Ordered";
        this.aggregates = [
            { field: 'amount', aggregate: 'sum' }
        ];
        this.state.group = [{ field: 'amount', aggregates: this.aggregates }];
        
        //necessary for grid displays that dont search
        this.disableCpSearchDialog();
    }

    rowClassFunction(context: RowClassArgs) {

            if(context.dataItem.isAdded) {
                return { isAdded: true }
            }
            else if(context.dataItem.isUpdated) {
                return { isUpdated: true }
            }
            else if(context.dataItem.inFinance) {
                return { inFinance: true }
            }
    }
    test() {
        this.gridData[0].isAdded = true;
        this.gridData[1].isAdded = true;
        this.gridData[5].isUpdated = true;
        this.gridData[9].isUpdated = true;
    }
    processGridData() {
        if (this.hasGridData) {
            for (let i = 0; i < this.gridData.length; i++) {
                if (!this.gridData[i].warehouse) {
                    this.gridData[i].warehouse = this.warehouseName(this.gridData[i].warehouseId);

                }
            }
        }
        if (CommonFunctions.hasArrayElementValue(this.gridData)) {
            this.aggregateResults = aggregateBy(this.gridData, this.aggregates);
            this.supplierNameCF = new MSCLFilterClass('supplierName', 'supplierName', this.gridData);
            this.inventoryNumberCF = new MSCLFilterClass('inventoryNumber', 'inventoryNumber', this.gridData);
            this.orderNumberCF = new MSCLFilterClass('orderNumber', 'orderNumber', this.gridData);
        }
        this.getDragReady();
    }
    getDragReady() {

        if (this.currentSubscription) {
            var subs = this.currentSubscription;
            if (this.destroy$) {
                this.destroy$.next('TODO: BILL LOOK AT THIS');
                this.destroy$.complete();
            }
            this.destroy$ = new Subject();
            this.currentSubscription.unsubscribe();
        }
        if (this.canDrag) {
            this.zone.onStable.pipe(take(1))
                .subscribe(() => this.currentSubscription = this.handleDragAndDrop());
        }
    }

    public dataStateChange(state: DataStateChangeEvent): void {
        if (state && state.group) {
            state.group.map(group => group.aggregates = this.aggregates);
        }
        this.state = state;
        this.getDragReady();
    }
    private handleDragAndDrop(): Subscription {
        const sub = new Subscription(() => { });
        let draggedItemIndex;
        const tableRows = Array.from(document.querySelectorAll('div.partsOrderedGridDiv > .k-grid tr'));
        const _this = this;
        tableRows.forEach(item => {
            this.renderer.setAttribute(item, 'draggable', 'true');
            const dragStart = fromEvent<DragEvent>(item, 'dragstart');
            const dragOver = fromEvent(item, 'dragover');
            const dragEnd = fromEvent(item, 'dragend');
            var dropItemIndex;
            var dataItem;
            sub.add(dragStart.pipe(
                tap(({ dataTransfer }) => {
                    try {
                        // Firefox won't drag without setting data
                        dataTransfer.setData('application/json', "");
                    } catch (err) {
                        // IE doesn't support MIME types in setData
                    }
                })
            ).subscribe(({ target }) => {
                const row: HTMLTableRowElement = <HTMLTableRowElement>target;
                draggedItemIndex = row.rowIndex;
                var data = _.cloneDeep(this.grid.data);
                dataItem = data.data[draggedItemIndex];
                //   dataItem.dragging = true;
            }));

            sub.add(dragEnd.subscribe((e: any) => {
                e.preventDefault();
                var event = _.cloneDeep(dataItem);
                event.detailType = 2;
                event.dropid = event.orderDetailId

                this.dropEvent.emit(event);
            }));
        });

        return sub;
    }
    customCheckBoxChanged(e: any, dataItem, rowIndex, column, columnIndex) {

    }
}
